import React from "react";
import Logo from '../Pic/Logo.png'
import Profile from '../Pic/Profile.jpg'
import './Header.css'

function Header() {
  return (
    <>
      <div className="grid md:grid-cols-2 sm:grid-cols-1 m-4 gap-4 md:gap-10 h-full select-none ">
        <div className="bg-indigo-200 h-full w-full rounded-3xl flex justify-center slideIn drop-shadow-lg">
          <img alt="Logo" className="object-cover h-full w-3/4 hover:opacity-80 hover:animate-pulse scale-x-125 scale-y-110 hover:scale-x-100 hover:scale-y-90 drop-shadow-2xl" src={Logo} />
        </div>
        <div className="bg-inherit h-full w-full rounded-3xl object-fill flex justify-center slideIn2 drop-shadow-lg">
          <img
            className="object-fill rounded-3xl hover:opacity-100 "
            src={Profile}
            alt="Profile"
          />
        </div>
      </div>
    </>
  );
}

export default Header;
